import { useDropzone } from 'react-dropzone';
import { useCallback, useEffect, useState } from 'react';
import { Button, Dialog, IconButton, Popover, Tooltip } from '@material-ui/core';
import { FileUpload } from './UploadFiles';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { I18n } from 'aws-amplify';
import { PropTypes } from 'prop-types';
import TooltipThumb from './TooltipThumb';
import { ButtonOption } from '../ticketList/DetailTicketList';

export const DropFile = ({ fileUploadList, setFileUploadList, setValue, register, name, ...props }) => {
    register(name);    
    const [publicForCustomer, setPublicForCustomer] = useState(0);
    const [isDisable, setIsDisable] = useState(false);
    const isUploadForEmailTicket = props.selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL || props.ticketType === Constant.TICKET_TYPE.EMAIL;
    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const [openOption, setOpenOption] = useState(null);
    const [openFileOption, setOpenFileOption] = useState(null);

    useEffect(() => {
        setPublicForCustomer(props.data.structure.publicForCustomer);

        setIsDisable(checkDisableField());

    }, [props.data.structure.publicForCustomer, props.detailTicket, props.hasEditFieldPermissions])

    const onDrop = useCallback(
        (acceptedFiles) => {
            handleDragFileOnChange(acceptedFiles);
            return;
        },
        [fileUploadList]
    );
    const { getRootProps, getInputProps } = useDropzone({ onDrop, disabled: isDisable });

    const handleDragFileOnChange = (fileList) => {
        let tempFileUploadList = [];
        for (let i = 0; i < fileList.length; i++){
            if (fileList[i]) {
                let fileUpload = { file: fileList[i], progress: 0, status: true, key: '' };
                setValue(name, 'fileUploaded');
                tempFileUploadList.push(fileUpload);
            }
            let newFileUploadList = [...fileUploadList, ...tempFileUploadList];
            setFileUploadList(newFileUploadList);
            setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);
        }

        if(!Utils.isEmptyArray(tempFileUploadList)) {
            props.clearErrors(name);
            setValue(name, 'fileUploaded');
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            if(props?.setOnChangeEdit){
                if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props?.onChangeEdit)
                }
            }
        } else {
            setValue(name, '');
        }
    };

    useEffect(() => {
        if (!Utils.isEmptyArray(fileUploadList) && isUploadForEmailTicket && props.setErrorCreateTicket) {
            let totalFileSize = 0;
            fileUploadList.forEach(file => {
                if (file?.file?.size) {
                    totalFileSize += parseInt(file?.file?.size);
                }
            })
            if (totalFileSize) {
                let convertTotalFileSizeToMB = Utils.convertByteToMB(totalFileSize)
                if (convertTotalFileSizeToMB > Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) {
                    props.setErrorCreateTicket(
                        name,
                        { type: 'manual', message: I18n.get('MGS-FILE-OVER-CAPACITY').replace('{{fileSize}}', Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) },
                        { shouldFocus: true }
                    );
                }
            } else {
                props.clearErrors(name); 
            }
        } else {
            props.clearErrors(name);
        }
    }, [fileUploadList]);

    const handleDeleteFile = (index) => {
        setOpenOption(null);
        setOpenFileOption(null);
        let newFileUploadList = cloneDeep(fileUploadList);
        newFileUploadList.splice(index, 1);
        setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);
        setFileUploadList([...newFileUploadList]);

        if(!Utils.isEmptyArray(newFileUploadList)) {
            setValue(name, 'fileUploaded');
            props.clearErrors(name);
        } else {
            setValue(name, '');
        }
    };

    const renderImage = () => {
        let contentChatList = [];
        if (!isDisable) {
            fileUploadList.forEach((fileUploadInfor, index) => {
                let item = { content: fileUploadInfor.file.name, fileSize: fileUploadInfor.file.size };
                const url = URL.createObjectURL(fileUploadInfor.file);
                contentChatList.push(
                    <li>
                        {Utils.isImageFile(fileUploadInfor.file.name) ? (
                            <>
                                <div
                                    className="class-relative cursor-default listmap-item"
                                    style={{ display: 'flex', gap: 5 }}
                                >
                                    <TooltipThumb
                                        value={`${item.content}(${Utils.formatBytes(
                                            item.fileSize
                                        )})`}
                                        className="titleDisplay"
                                    >
                                        <img
                                            alt=""
                                            src={url}
                                            style={{
                                                height: 50,
                                                width: 70
                                            }}
                                            onClick={() => setOpenPreviewImage(url)}
                                        />
                                    </TooltipThumb>
                                    <div
                                        style={{
                                            height: 50,
                                            backgroundColor: '#ecedef',
                                            width: 20,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                        onClick={e => {
                                            setOpenFileOption({ ...item, index, isNewImg: true });
                                            setOpenOption(e.currentTarget);
                                        }}
                                    >
                                        <img src="/assets/image/icon-more-panel.svg" alt="" />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <FileUpload
                                    key={index}
                                    fileUploadInfor={fileUploadInfor}
                                    fileUploading={props.fileUploading}
                                    chatPost={item}
                                ></FileUpload>
                                <div className="lstName-item">
                                    <IconButton
                                        onClick={() => handleDeleteFile(index)}
                                        className="itemDelete"
                                    >
                                        <img src="/assets/image/icon-closeUpfile.svg" alt="" />
                                    </IconButton>
                                </div>
                            </>
                        )}
                    </li>
                );
            });
        }
        return contentChatList;
    };

    const isCustomerHasFileUpload = (contentChatList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName !== Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        publicForCustomer !== Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE && 
        Utils.isEmptyArray(contentChatList)
    }

    const isCustomerKnowledgeHasFileUpload = (contentChatList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        !props?.hasEditFieldPermissions && 
        Utils.isEmptyArray(contentChatList)
    }

    const renderLabel = () => {
        const contentChatList = renderImage();
        if (isCustomerHasFileUpload(contentChatList) || isCustomerKnowledgeHasFileUpload(contentChatList)) {
            return '';
        }

        return (
            <>
                {props?.isTooltipTitle ? (
                    <div className="d-flex">
                        <Tooltip title={props?.label}>
                            <span className="form-addTicket-label text-truncate">
                                <label
                                    className={
                                        'text-truncate line-height-18' +
                                        (publicForCustomer
                                            ? 'form-addTicket-label-color'
                                            : 'form-addTicket-label')
                                    }
                                >
                                    {props?.label}
                                </label>
                            </span>
                        </Tooltip>
                        {props.data.structure.required && (
                            <span className="required padding-left-4">*</span>
                        )}
                    </div>
                ) : (
                    <label
                        className={
                            publicForCustomer
                                ? 'form-addTicket-label-color'
                                : 'form-addTicket-label'
                        }
                    >
                        {props?.label}
                        {props.data.structure.required && <span className="required">*</span>}
                    </label>
                )}
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement="top" arrow>
                        <img
                            style={{ paddingTop: '10px' }}
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </>
        );
    }

    const checkDisableField = () => {
        return (props.data.structure.publicForCustomer === 2 || !Utils.isEmptyString(props.detailTicket?.deletedAt) || props.hasEditFieldPermissions === false );
    }

    const isDisplayBoxUploadFile = () => {
        if (!Utils.isEmpty(props.addTicket)) {
            return true;
        }

        if (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE) {
            return props?.hasEditFieldPermissions;
        }

        return publicForCustomer === Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
    }

    return (
        <div className="form-addTicket">
            <div className="cell-prod-status gap-8">{renderLabel()}</div>

            <div className="form-addTicket-input">
                <div className="lstName-file">
                    <ul>{renderImage()}</ul>
                </div>

                {isDisplayBoxUploadFile() && (
                    <div
                        className="formUpload"
                        {...getRootProps()}
                        data-cy="drop-file-input-upload"
                    >
                        <input disabled={isDisable} {...getInputProps()} draggable="false" />
                        <label htmlFor="contained-button-file">
                            <Button disabled={isDisable} variant="contained" component="span">
                                <div className="formUpload-item">
                                    <img
                                        src="/assets/image/icon-upload.svg"
                                        alt=""
                                        onDragStart={e => {
                                            e.preventDefault();
                                        }}
                                    />
                                    <span className="formUpload-txt">
                                        {I18n.get('MSG-DRAG-DROP-FILE')}
                                    </span>
                                </div>
                            </Button>
                        </label>
                    </div>
                )}
                {props?.errorlist && props.errorlist[name]?.message && (
                    <div className="upload-file-error">{props.errorlist[name]?.message}</div>
                )}
            </div>

            <Popover
                open={Boolean(openOption) || false}
                anchorEl={openOption}
                onClose={() => {
                    setOpenFileOption(null);
                    setOpenOption(null);
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {!Utils.isEmptyObject(openFileOption) &&
                        !openFileOption?.originId?.includes('post') && (
                            <ButtonOption
                                disabled={isDisable}
                                onClick={() => {
                                    handleDeleteFile(openFileOption?.index);
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 400,
                                        fontFamily: 'Zen Kaku Gothic New'
                                    }}
                                >
                                    {I18n.get('DELETE')}
                                </span>
                            </ButtonOption>
                        )}
                </div>
            </Popover>

            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </div>
    );
};

DropFile.propTypes = {
    data: PropTypes.any,
    detailTicket: PropTypes.any,
    hasEditFieldPermissions: PropTypes.any,
    selectTicketType: PropTypes.any,
    ticketType: PropTypes.any,
    errorlist: PropTypes.any,
    componentName: PropTypes.any,
    addTicket: PropTypes.any,
    fileUploadList: PropTypes.any,
    setFileUploadList: PropTypes.any,
    setValue: PropTypes.any,
    register: PropTypes.any,
    name: PropTypes.any
};
